import template from "./entity-inventory.html";
import "./entity-inventory.less";
import { FORM_ENTITY_INVENTORIES } from "../../../../../../routes";
import inventoryOperationsModal from "./entity-inventory-operations/entity-inventory-operations";

export function controller(appState, loadingService, api, $logger, $uibModal) {
	const ctrl = this;

	ctrl.$onInit = () => {
		// type InventoryItem  = {
		// 	Id: number;
		// 	Item: Entity;
		// 	LastModified: string;
		// 	Operations: InventoryOperation[];
		// };

		ctrl.inventoriedItems = [];  // InventoryItem[]

		loadInventories();
	};

	ctrl.viewOperations = (inventoryItem) => {
		$uibModal.open({
			component: "entity-inventory-operations",
			size: "md",
			backdrop: "static",
			resolve: {
				inventoryItem: () => inventoryItem,
				forEntity: () => ctrl.entity
			}
		});
	};

	async function loadInventories() {
		const route = FORM_ENTITY_INVENTORIES(appState.forms.selected.Id, ctrl.entity.Id);

		const promise = api.get(route);

		ctrl.inventoriedItems = await loadingService.watch(promise);
	}
}

export { inventoryOperationsModal };
export default angular.module("vesl.components.entity-inventory", [inventoryOperationsModal])
	.component("entityInventory", {
		controller,
		template,
		bindings: {
			entity: "<",
			put: "=",
			post: "="
		}
	})
	.name;
